import axios from "axios";
import { useGlobal } from "../../GlobalContext";

const signageUrl = process.env.REACT_APP_API_URL;
const apiAdminUrl = process.env.REACT_APP_ADMIN_API_URL;

export function GetCookie() {
const { dashboardToken } = useGlobal();
return dashboardToken??"";
}

export function getHeader(token) {
return {
    "Content-Type": "application/json; charset=UTF-8",
    Accept: "application/json",
    "Access-Control-Allow-Origin": "*", // Required for CORS support to work
    Authorization: token,
};
}

export const getdockCountApi = async (token) => {
    
    try {
        const response = await axios.get(signageUrl + `dockdashboard/count`, {
            headers: getHeader(token),
        });
        return response;
    } catch (err) {
        console.error("Error fetching category:", err);
    } finally {
    }
};

export const getHistoryCountApi = async (token) => {
  try {
    const response = await axios
      .post(signageUrl + `dockdashboard/history_count`, {"start_date":''}, { headers: getHeader(token) })
      .then((response) => {
        return response;
      })
      .catch((error) => {
        console.log("error...", error.response);
        return error.response;
      });
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

export const getdocktimingsApi = async (token) => {
    try {
        const response = await axios.get(signageUrl + `dockdashboard/timings`, {
            headers: getHeader(token),
        });
        return response;
    } catch (err) {
        console.error("Error fetching category:", err);
    } finally {
    }
};
export const getdockfreedocksApi = async (token) => {
    try {
        const response = await axios.get(signageUrl + `dockdashboard/freedocks`, {
            headers: getHeader(token),
        });
        return response;
    } catch (err) {
        console.error("Error fetching category:", err);
    } finally {
    }
};
export const getdocklocationinoutApi = async (token) => {
    try {
        const response = await axios.post(signageUrl + `dockdashboard/location_in_out`, {}, {
            headers: getHeader(token),
        });
        return response;
    } catch (err) {
        console.error("Error fetching category:", err);
    } finally {
    }
};
export const getdocklivemonitorApi = async (token) => {
    try {
        const response = await axios.get(signageUrl + `dockdashboard/livemonitor`, {
            headers: getHeader(token),
        });
        return response;
    } catch (err) {
        console.error("Error fetching category:", err);
    } finally {
    }
};

export const getAverageDurationApi = async (data,token) => {
  try {
    const response = await axios
      .post(signageUrl + "dock/web/avarageduration", data, { headers: getHeader(token) })
      .then((res) => res)
      .catch((error) => {
        console.log("Error in getAverageDurationApi:", error.response);
        return error.response;
      });
    return response;
  } catch (err) {
    console.error("Unexpected error in getAverageDurationApi:", err);
  }
};

export const getDockStatusApi = async (token) => {
    try {
        const response = await axios.get(signageUrl + `dockdashboard/dock_status`, {
            headers: getHeader(token),
        });
        return response;
    } catch (err) {
        console.error("Error fetching category:", err);
    } finally {
    }
};
